import { useState, useEffect } from "react";
import Block from '../new/block1';

// Composant EditableBlockList
const EditableBlockList = ({ onClinicChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [blocks, setBlocks] = useState([]);   // Questions dynamiques
  const [questions, setQuestions] = useState([
    { label: "Auscultation", content: ".Red eyes .Red tongue" },
    { label: 'Auscultation', content: '. Ras' },
    { label: 'Palpation', content: '. Seins fragiles, . Ras' }
  ]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Ajouter un bloc de question dynamique
  const handleAddBlock = () => {
    const newBlock = { label: `New Question ${Date.now()}`, id: Date.now(), response: "" };
    setBlocks((prevBlocks) => {
      const updatedBlocks = [...prevBlocks, newBlock];
      // Mettre à jour les questions et les blocs dans le parent
      onClinicChange([...questions, ...updatedBlocks], 'clinical_exam');
      return updatedBlocks;
    });
  };

  // Gérer le changement du label dans les blocs dynamiques
  const handleBlockLabelChange = (blockId, newLabel) => {
    const updatedBlocks = blocks.map(block =>
      block.id === blockId ? { ...block, label: newLabel } : block
    );
    setBlocks(updatedBlocks);

    // Envoyer les données mises à jour au parent
    onClinicChange([...questions, ...updatedBlocks], 'clinical_exam');
  };

  // Gérer le changement de contenu dans les blocs
  const handleBlockContentChange = (blockId, newContent) => {
    const updatedBlocks = blocks.map(block =>
      block.id === blockId ? { ...block, response: newContent } : block
    );
    setBlocks(updatedBlocks);

    // Envoyer les données mises à jour au parent
    onClinicChange([...questions, ...updatedBlocks], 'clinical_exam');
  };

  useEffect(() => {
    // Initialiser les questions par défaut dans le parent
    onClinicChange([...questions, ...blocks], 'clinical_exam');
  }, [questions, blocks]);

  return (
    <div>
      <div className="position-relative">
        <p
          className="py-3 fw-bold text-center"
          style={{ background: '#1A5D1A47', borderRadius: '15px' }}
          onClick={toggleDropdown}
        >
          Clinical examinations
        </p>
        <i
          className="bi bi-caret-down-fill pos1"
          style={{ color: '#1A5D1A' }}
        ></i>
      </div>

      {isOpen && (
        <div className="row m-4">
          <p className="ms-4 fw-bold">Notez les résultats de l’examen clinique effectué sur le patient </p>

          {/* Affichage des questions par défaut */}
          {questions.map((question, index) => (
            <div key={index} className="col-12 mx-auto mb-3">
              <Block
                initialLabel={question.label}
                initialContent={question.content}
                onContentChange={(newContent) => {
                  const updatedQuestions = questions.map((q, i) =>
                    i === index ? { ...q, content: newContent } : q
                  );
                  setQuestions(updatedQuestions);
                  onClinicChange(updatedQuestions, 'clinical_exam'); // Mise à jour vers le parent
                }}
                onLabelChange={(newLabel) => {
                  const updatedQuestions = questions.map((q, i) =>
                    i === index ? { ...q, label: newLabel } : q
                  );
                  setQuestions(updatedQuestions);
                  onClinicChange(updatedQuestions, 'clinical_exam'); // Mise à jour vers le parent
                }}
              />
            </div>
          ))}

          {/* Affichage des blocs dynamiques */}
          {blocks.map((block) => (
            <div key={block.id} className="col-12 mx-auto mb-3">
              <Block
                initialLabel={block.label}
                initialContent={block.response || ""}
                onContentChange={(newContent) => handleBlockContentChange(block.id, newContent)}
                onLabelChange={(newLabel) => handleBlockLabelChange(block.id, newLabel)}
              />
            </div>
          ))}

          <div className="d-flex justify-content-end">
            <button
              className="btn btn-prim"
              style={{ color: '#0056B3' }}
              onClick={handleAddBlock} // Ajouter un nouveau bloc de question
            >
              <i className="bi bi-plus-circle-fill me-2"></i>
              <span style={{ textDecoration: 'underline' }}>Add question</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditableBlockList;
